import { css, html, LitElement } from "lit";

export class SettingsFooter extends LitElement {
	static styles = css`
    :host {
      display: block;
      min-inline-size: 0;
      color: var(--z-shell-text, #111111);
      font: 400 11px / 1.4 var(--z-shell-font, Tahoma, sans-serif);
    }

    .footer {
      display: grid;
      gap: 7px;
      padding-block-start: 10px;
      border-block-start: 1px solid var(--z-shell-surface-mid, #808080);
      box-shadow: inset 0 1px 0 var(--z-shell-surface-light, #ffffff);
      text-align: center;
    }

    h2,
    p {
      margin: 0;
    }

    h2 {
      font-size: 12px;
    }

    .about {
      display: grid;
      gap: 3px;
    }

    a {
      color: #0000ee;
      text-decoration: underline;
      text-underline-offset: 1px;
    }

    a:visited {
      color: #551a8b;
    }

    a:focus-visible {
      outline: 1px dotted var(--z-shell-focus, #0a246a);
      outline-offset: 2px;
    }

    .signature {
      color: var(--z-shell-text-muted, #585858);
    }

    @media (max-width: 599px) {
      a {
        display: inline-flex;
        align-items: center;
        min-block-size: 40px;
      }
    }
  `;

	render() {
		return html`
      <footer class="footer">
        <section class="about" aria-labelledby="settings-about-title">
          <h2 id="settings-about-title">About Zagreus</h2>
          <p>A retro desktop for your browser, circa 2000, running ZagreOS.</p>
          <p>
            Powered by
            <a href="https://webamp.org/" target="_blank" rel="noopener noreferrer">Webamp</a>,
            <a href="https://www.azuracast.com/" target="_blank" rel="noopener noreferrer"
              >AzuraCast</a
            >, and
            <a href="https://techn.is/" target="_blank" rel="noopener noreferrer">Technis</a>.
          </p>
        </section>
        <p class="signature">
          Made by @<a href="https://github.com/jovalle" target="_blank" rel="noopener noreferrer"
            >jovalle</a
          >
          with <span aria-label="love">❤️</span> and
          <span aria-label="Dominican coffee">🇩🇴☕️</span>
        </p>
      </footer>
    `;
	}
}

if (!customElements.get("settings-footer")) {
	customElements.define("settings-footer", SettingsFooter);
}
